<div class="model-selector-container">
  <ion-select
    class="model-selector-label"
    label=""
    label-placement="stacked"
    [placeholder]="placeholder | translate"
    [value]="selectedProjectId"
    (ionChange)="handleChange($event)"
    interface="popover"
    [interfaceOptions]="{ header: headerText | translate }"
    [disabled]="!hasProjects">
    <ion-select-option *ngFor="let project of projects" [value]="project.id">
      {{project.name}}
    </ion-select-option>
  </ion-select>
  <div *ngIf="!hasProjects" class="no-projects-message">
    <ion-text color="medium">
      <small>{{ 'COMMON.NO_PROJECTS_AVAILABLE' | translate }}</small>
    </ion-text>
  </div>
</div>
